export const omit = (obj: object, propertyToOmit: string) => {
  const result = { ...obj };
  delete result[propertyToOmit];
  return result;
};
